import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  section: {
    backgroundColor: '#2D2424',
    color: 'white'
  },
  card: {
    textAlign: 'center'
  },
  toolbar: theme.mixins.toolbar
}))